export const studentreasures = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 15,
  inputPaddingInline: 15,

  inputHeight: 30,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Open Sans", sans-serif',
  inputColor: "#707070",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 700,

  inputBorderColor: "#707070",
  inputBorderWidth: 1,
  inputBorderRadius: 3,

  inputHoverColor: "#707070",
  inputHoverBorderColor: "#707070",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 15,
  selectPaddingInline: 15,

  selectHeight: 30,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Open Sans", sans-serif',
  selectColor: "#707070",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 700,

  selectBorderColor: "#707070",
  selectBorderWidth: 1,
  selectBorderRadius: 3,

  selectHoverColor: "#707070",
  selectHoverBorderColor: "#707070",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 15,
  textAreaPaddingInline: 15,

  textAreaHeight: 75,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Open Sans", sans-serif',
  textAreaColor: "#707070",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 700,

  textAreaBorderColor: "#707070",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 3,

  textAreaHoverColor: "#707070",
  textAreaHoverBorderColor: "#707070",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#707070",
  placeholderFontFamily: '"Open Sans", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 700,
  placeholderHoverColor: "#707070",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#FFFFFF",
  fieldLabelFontWeight: 700,
  fieldLabelColorAsterisk: "#FFFFFF",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Open Sans", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#FFFFFF",
  descriptionFontSize: 12,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Open Sans", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 14,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 3,
  checkboxUncheckedBorderColor: "#FFFFFF",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBorderColor: "#FFFFFF",
  checkboxCheckedColor: "#0096D6",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Open Sans", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 700,
  checkboxLabelColor: "#FFFFFF",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 14,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#FFFFFF",
  radioUncheckedBackgroundColor: "#FFFFFF",
  radioCheckedBackgroundColor: "#0096D6",
  radioCheckedBorderColor: "#FFFFFF",

  radioAlignment: "none",

  radioLabelFontFamily: '"Open Sans", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 700,
  radioLabelColor: "#FFFFFF",

  // **********************************
  // submit button

  submitMarginTop: 38,
  submitFontSize: 16,
  submitFontFamily: "'Open Sans', sans-serif",
  submitWidth: 120,
  submitWidthUnits: "px",
  submitHeight: 45,
  submitBorderRadius: 12,
  submitBorderWidth: 1,
  submitBackground: "#8DC63F",
  submitColor: "#383838",
  submitBorderColor: "#FFFFFF",
  submitBackgroundHover: "#8DC63F",
  submitBorderColorHover: "#FFFFFF",
  submitColorHover: "#383838",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 400,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  